module.exports = __webpack_public_path__ + "assets/bar-chart2.7e909916.svg";